import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-20b5c48a")

_pushScopeId("data-v-20b5c48a")
const _hoisted_1 = { class: "notfound flex justify-center items-center relative px-5" }
const _hoisted_2 = { class: "notfound__wrapper flex flex-column justify-center" }
const _hoisted_3 = { class: "notfound__header" }
const _hoisted_4 = { class: "text-center notfound__desc" }
const _hoisted_5 = { class: "text-center notfound__desc" }
const _hoisted_6 = { class: "notfound__main font-size-14 mt-5 mb-8" }
const _hoisted_7 = { class: "text-center" }
const _hoisted_8 = { class: "text-center" }
const _hoisted_9 = { class: "notfound__button flex justify-items-center items-center flex-column" }
const _hoisted_10 = /*#__PURE__*/_createVNode("span", { class: "cp-icon-sign-in text-2xl mr-3" }, null, -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Button = _resolveComponent("Button")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _createVNode("p", _hoisted_4, _toDisplayString(_ctx.t('404.desc404')), 1),
        _createVNode("p", _hoisted_5, _toDisplayString(_ctx.t('404.descNotFound404')), 1)
      ]),
      _createVNode("div", _hoisted_6, [
        _createVNode("p", _hoisted_7, _toDisplayString(_ctx.t('404.descNotFoundMain')), 1),
        _createVNode("p", _hoisted_8, _toDisplayString(_ctx.t('404.descNotFound')), 1)
      ]),
      _createVNode("div", _hoisted_9, [
        _createVNode("div", null, [
          _createVNode(_component_Button, {
            class: "mb-4 w-back",
            label: _ctx.t('404.homePage'),
            variant: "primary",
            onClick: _ctx.backToHome
          }, null, 8, ["label", "onClick"]),
          _createVNode(_component_Button, {
            class: "w-back",
            label: _ctx.t('404.signOut'),
            variant: "outline-primary",
            onClick: _ctx.handleLogout
          }, {
            default: _withId(() => [
              _hoisted_10
            ]),
            _: 1
          }, 8, ["label", "onClick"])
        ])
      ])
    ])
  ]))
})